import { DocumentChecklists } from '../../../cimsPage/instances/concrete'
import { CreateViewEditRemove } from '../../common'

const documentChecklists = CreateViewEditRemove({
  page: DocumentChecklists,
  object: 'Document Checklist Item',
  create: 'e9e4c2e7-fa68-4dfe-a465-1cd01eba3dde',
  view: 'b9872cd2-eaee-48fc-a822-51703462add8',
  edit: '3c499aa0-2150-4d51-addc-96705ff3f8bc',
  remove: '5c63e80c-0284-4aa4-870c-43f88f551a4f',
})

export const CreateDocumentChecklistItem = documentChecklists.Create
export const ViewDocumentChecklistItem = documentChecklists.View
export const EditDocumentChecklistItem = documentChecklists.Edit
export const RemoveDocumentChecklistItem = documentChecklists.Remove

export type DocumentChecklistPermission =
  | typeof CreateDocumentChecklistItem
  | typeof ViewDocumentChecklistItem
  | typeof EditDocumentChecklistItem
  | typeof RemoveDocumentChecklistItem
